import { inject, Injectable } from '@angular/core';
import { EntityOperations, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { HttpClientGetJsonOptions } from '@wdx/shared/utils';
import { EntityTypeActionExportResolverService } from '@wdx/clmi/clmi-swagger-gen/api-services';

@Injectable({
    providedIn: 'root',
})
export class OperationsService extends BaseApiService {
    private entityTypeActionExportResolverService = inject(EntityTypeActionExportResolverService);
    getOperationsForEntity(
        entityType: SystemEntity,
    ): Observable<EntityOperations> {
        return this.get<EntityOperations>(
            `${entityType?.toLowerCase()}/operation`,
        );
    }

    getOperationsForId(
        entityType: SystemEntity,
        entityId: string,
    ): Observable<EntityOperations> {
        return this.get<EntityOperations>(
            `${entityType?.toLowerCase()}/${entityId}/operation`,
        );
    }

    patchActionWithURL(
        entityType: SystemEntity,
        entityId?: string,
        url?: string,
        options: HttpClientGetJsonOptions = {},
    ): Observable<any> {
        if (url?.toLowerCase() === 'export' && !entityId) {

            const service = this.entityTypeActionExportResolverService.getService(entityType);
            if(service) {
                return service.post(null, options);
            }
        }
        const path = entityId
            ? `${entityType?.toLowerCase()}/${entityId}/action/${url}`
            : `${entityType?.toLowerCase()}/action/${url}`;

        return this.patch(path, null, options);
    }
}
